import BaseModel from '../core/BaseModel'
export default class WarrantyRepairProductSnHasServiceParkModel extends BaseModel {
    constructor() {
        super({ 
                name: "warranty_repair_product_sn_has_service_park",
                tableName: 'core_warranty_repair_product_sn_has_service_park'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: 'warranty_repair_product_serial_number_id service_pack_id info_service_pack is_free total_price arr_wr_product_serial_service_supplies(order_by: {id: desc}, where: {status: {_eq: "1"}}) { id discount money_discount info_service_supplies is_free modified_date number service_pack_service_supplies_id status total_price warranty_repair_product_sn_has_service_park_id }',
                display: false
            },
        },)
    }

}